export const UNAUTHORIZED = 'UNAUTHORIZED'

export const FETCH_BASICS = 'FETCH_BASICS'

export const LOGOUT = 'LOGOUT'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export const SET_APP_STATE = 'SET_APP_STATE'

export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN'

export const unAuthorized = () => ({
  type: UNAUTHORIZED
})

export const fetchBasics = () => ({
  type: FETCH_BASICS
})

export const logout = () => ({
  type: LOGOUT
})

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS
})

export const setAppState = (payload) => ({
  type: SET_APP_STATE,
  payload
})

export const setCsrfToken = (payload) => ({
  type: SET_CSRF_TOKEN,
  payload
})
